import OrderControlManagePage from './OrderControlManagePage';

export default function OrderControlGlobalPage() {
  return <OrderControlManagePage mode="global" title="全局控獎" />;
}
